import React, { useState } from 'react';
import { IsAuth } from '../../utils/Auth';
import { Route, Redirect } from 'react-router-dom';
import LogIn1 from '../login/LogIn1';
export const PrivateRoute = ({ component: Component, ...rest }) => (
  // const [openSign, setOpenSign] = useState(false);
  // const signupClickHandler = () => {
  //   setOpenSign(!openSign);
  // };

  <Route
    {...rest}
    render={(props) => (IsAuth() ? <Component {...props} /> : <LogIn1 />)}
  ></Route>
);
//  to={{
//             pathname: '/',
//             state: { from: props.location },
// }}

{
  /* <Redirect to='/' /> */
}
